import React from "react";
import { Select } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

// We need to handle the generic types for Select options
interface TrebbleSelectProps<ValueType = any, OptionType extends object = any> 
  extends React.ComponentProps<typeof Select<ValueType, OptionType>> {
  useEditorTheme?: boolean;
  popupMatchSelectWidth?: boolean;
  placement?: 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topRight';
}

const TrebbleSelect = <ValueType = any, OptionType extends object = any>(
  { useEditorTheme, popupMatchSelectWidth, placement, ...restProps }: TrebbleSelectProps<ValueType, OptionType>
) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Select<ValueType, OptionType> 
        popupMatchSelectWidth={popupMatchSelectWidth}
        placement={placement}
        {...restProps} 
      />
    </TrebbleConfigProvider>
  );
};

// Add sub-components like Option, OptGroup if needed, similar to Skeleton
TrebbleSelect.Option = Select.Option;
TrebbleSelect.OptGroup = Select.OptGroup;

export default TrebbleSelect; 